var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFoam(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "none",
      display: "block",
      zIndex: 1,
      position: "relative"
    },
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 1920 929",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(960,464.5) scale(1,1) translate(-960,-464.5)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg-0.5666266044896757",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff00ff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 1694 465 C 1694 651 1269 813 1092 870 C 915 927 576 972 467 822 C 358 672 414 297 523 147 C 632 -3 922 -21 1099 36 C 1276 93 1694 279 1694 465",
    fill: "url(#lg-0.5666266044896757)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;0.3333333333333333;0.6666666666666666;1",
    calcmod: "spline",
    keySplines: "0.3 0.1 0.7 0.9;0.3 0.1 0.7 0.9;0.3 0.1 0.7 0.9",
    begin: "-4s",
    values: "M 1694 465 C 1694 651 1269 813 1092 870 C 915 927 576 972 467 822 C 358 672 414 297 523 147 C 632 -3 922 -21 1099 36 C 1276 93 1694 279 1694 465;M 1624 465 C 1624 651 1291 882 1114 939 C 937 996 547 996 437 845 C 327 694 418 301 528 150 C 638 -1 915 1 1092 59 C 1269 117 1624 279 1624 465;M 1649 465 C 1649 642 1258 809 1090 864 C 922 919 629 924 525 781 C 421 638 447 310 551 167 C 655 24 942 -51 1110 4 C 1278 59 1649 288 1649 465;M 1694 465 C 1694 651 1269 813 1092 870 C 915 927 576 972 467 822 C 358 672 414 297 523 147 C 632 -3 922 -21 1099 36 C 1276 93 1694 279 1694 465"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 1586 465 C 1586 630 1269 882 1112 933 C 955 984 666 882 569 748 C 472 614 429 283 526 149 C 623 15 950 -40 1107 11 C 1264 62 1586 300 1586 465",
    fill: "url(#lg-0.5666266044896757)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;0.3333333333333333;0.6666666666666666;1",
    calcmod: "spline",
    keySplines: "0.3 0.1 0.7 0.9;0.3 0.1 0.7 0.9;0.3 0.1 0.7 0.9",
    begin: "-4s",
    values: "M 1586 465 C 1586 630 1269 882 1112 933 C 955 984 666 882 569 748 C 472 614 429 283 526 149 C 623 15 950 -40 1107 11 C 1264 62 1586 300 1586 465;M 1556 465 C 1556 643 1285 890 1116 945 C 947 1000 536 993 431 849 C 326 705 417 290 521 146 C 625 2 955 -97 1124 -42 C 1293 13 1556 287 1556 465;M 1582 465 C 1582 649 1296 904 1121 961 C 946 1018 615 943 507 794 C 399 645 344 244 452 95 C 560 -54 954 -113 1129 -56 C 1304 1 1582 281 1582 465;M 1586 465 C 1586 630 1269 882 1112 933 C 955 984 666 882 569 748 C 472 614 429 283 526 149 C 623 15 950 -40 1107 11 C 1264 62 1586 300 1586 465"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 1538 465 C 1538 626 1222 751 1069 801 C 916 851 589 932 495 802 C 401 672 453 295 548 165 C 643 35 948 -19 1101 31 C 1254 81 1538 304 1538 465",
    fill: "url(#lg-0.5666266044896757)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;0.3333333333333333;0.6666666666666666;1",
    calcmod: "spline",
    keySplines: "0.3 0.1 0.7 0.9;0.3 0.1 0.7 0.9;0.3 0.1 0.7 0.9",
    begin: "-4s",
    values: "M 1538 465 C 1538 626 1222 751 1069 801 C 916 851 589 932 495 802 C 401 672 453 295 548 165 C 643 35 948 -19 1101 31 C 1254 81 1538 304 1538 465;M 1573 465 C 1573 644 1279 865 1108 920 C 937 975 576 965 471 820 C 366 675 431 302 536 157 C 641 12 953 -96 1124 -41 C 1295 14 1573 286 1573 465;M 1500 465 C 1500 627 1233 780 1079 830 C 925 880 597 928 502 797 C 407 666 435 283 530 152 C 625 21 944 -10 1098 40 C 1252 90 1500 303 1500 465;M 1538 465 C 1538 626 1222 751 1069 801 C 916 851 589 932 495 802 C 401 672 453 295 548 165 C 643 35 948 -19 1101 31 C 1254 81 1538 304 1538 465"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 1542 465 C 1542 648 1295 903 1121 960 C 947 1017 645 920 537 772 C 429 624 378 268 486 120 C 594 -28 934 -48 1108 9 C 1282 66 1542 282 1542 465",
    fill: "url(#lg-0.5666266044896757)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;0.3333333333333333;0.6666666666666666;1",
    calcmod: "spline",
    keySplines: "0.3 0.1 0.7 0.9;0.3 0.1 0.7 0.9;0.3 0.1 0.7 0.9",
    begin: "-4s",
    values: "M 1542 465 C 1542 648 1295 903 1121 960 C 947 1017 645 920 537 772 C 429 624 378 268 486 120 C 594 -28 934 -48 1108 9 C 1282 66 1542 282 1542 465;M 1504 465 C 1504 641 1287 904 1120 958 C 953 1012 619 929 516 787 C 413 645 424 292 527 150 C 630 8 916 32 1083 86 C 1250 140 1504 289 1504 465;M 1474 465 C 1474 630 1268 877 1111 928 C 954 979 647 896 550 763 C 453 630 378 245 475 112 C 572 -21 941 -11 1098 40 C 1255 91 1474 300 1474 465;M 1542 465 C 1542 648 1295 903 1121 960 C 947 1017 645 920 537 772 C 429 624 378 268 486 120 C 594 -28 934 -48 1108 9 C 1282 66 1542 282 1542 465"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 1544 465 C 1544 627 1226 760 1072 810 C 918 860 651 889 556 758 C 461 627 473 311 568 180 C 663 49 957 -49 1111 1 C 1265 51 1544 303 1544 465",
    fill: "url(#lg-0.5666266044896757)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;0.3333333333333333;0.6666666666666666;1",
    calcmod: "spline",
    keySplines: "0.3 0.1 0.7 0.9;0.3 0.1 0.7 0.9;0.3 0.1 0.7 0.9",
    begin: "-4s",
    values: "M 1544 465 C 1544 627 1226 760 1072 810 C 918 860 651 889 556 758 C 461 627 473 311 568 180 C 663 49 957 -49 1111 1 C 1265 51 1544 303 1544 465;M 1541 465 C 1541 630 1272 889 1115 940 C 958 991 598 932 501 798 C 404 664 391 254 488 121 C 585 -12 916 66 1073 117 C 1230 168 1541 300 1541 465;M 1530 465 C 1530 641 1252 795 1085 849 C 918 903 535 990 432 848 C 329 706 372 254 475 112 C 578 -30 928 -6 1095 48 C 1262 102 1530 289 1530 465;M 1544 465 C 1544 627 1226 760 1072 810 C 918 860 651 889 556 758 C 461 627 473 311 568 180 C 663 49 957 -49 1111 1 C 1265 51 1544 303 1544 465"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoam);
export default __webpack_public_path__ + "static/media/foam.72468b59fece9d61eb1e18fdd8a85a52.svg";
export { ForwardRef as ReactComponent };